<template>
  <LinkButton
    v-if="isInKompaliste"
    text
    tag="a"
    :href="compaListLink"
    class="kompaliste-link"
  >
    Weitere Informationen zur Kompatibilität
    <Arrow
      direction="right"
      class="kompaliste-link__icon"
      tag="span"
    />
  </LinkButton>
</template>

<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { LinkButton, Arrow } from '@i22-td-smarthome/component-library';
import { useNuxtApp } from '#imports';

const props = defineProps({
  eans: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
});

const { $store } = useNuxtApp();

const isInKompaliste = computed(() =>
  $store.getters['offers/compaEanList']?.includes(props.eans?.[0])
);

const compaListLink = computed(() => {
  const baseUrl = 'https://www.telekom.de/smarte-produkte/smart-home/kompatible-geraete';
  if (props.eans.length === 0) {
    return baseUrl;
  }

  return `${baseUrl}?ean=${encodeURIComponent(props.eans[0])}`;
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.kompaliste-link {
  display: flex;
  align-items: center;
  gap: 0.5 * $grid-base;
  margin-block: 2 * $grid-base;

  &__icon {
    position: relative;
    color: currentColor;
    width: 0.7em;
    height: 0.5em;
  }
}
</style>
